<template>
  <div class="list-file-directories">
    <b-overlay variant="light" opacity=".3" blur="2px" :show="loading">
      <h3 v-if="!loading" class="h5">Filtrar por diretórios</h3>
      <ul v-if="!loading && rootDirectories.length" class="mb-3">
        <list-file-directories-item
          v-for="item in rootDirectories"
          :key="item.id || item.nome"
          :value="modelValue"
          :item="item"
          :items="estrutura"
          @input="modelValue = $event"
        />
        <div class="px-3" v-if="modelValue">
          <b-button
            size="sm"
            variant="outline-exitos"
            class="w-100 py-2 mt-3 shadow-none"
            @click="modelValue = null"
          >
            <font-awesome-icon icon="filter-circle-xmark" />
            Limpar filtro
          </b-button>
        </div>
      </ul>

      <div v-else-if="!loading" class="text-muted small">
        Nenhum diretório encontrado.
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ListFileDirectoriesItem from "./ListFileDirectoriesItem.vue";
import { modelValue } from "@/mixins/modelValue";

export default {
  name: "ListFileDirectories",
  mixins: [modelValue("value", "input")],
  components: {
    ListFileDirectoriesItem,
  },
  props: {
    value: null,
  },
  computed: {
    ...mapState("files", ["estrutura", "loading"]),
    rootDirectories() {
      return this.estrutura.filter((item) => item.file_folder_id === null);
    },
  },
  methods: {
    ...mapActions("files", ["ActionGetFilesEstrutura"]),
  },
  async created() {
    await this.ActionGetFilesEstrutura();
  },
};
</script>

<style lang="scss">
.list-file-directories {
  ul {
    list-style: none;
    padding-left: 0;
  }

  .directory-children > ul {
    padding-left: 1.5rem;
    margin-top: 0.35rem;
  }

  .directory-row {
    display: flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    color: var(--dark);
    .show-on-hover {
      display: none;
    }

    &:hover {
      background: rgba(34, 83, 115, 0.1);
    }

    &.active {
      color: var(--exitos);
      background: rgba(34, 83, 115, 0.1);
    }
  }

  .directory-toggle,
  .directory-toggle-placeholder {
    width: 1rem;
    text-align: center;
    color: #6c757d;
    flex: 0 0 1rem;
  }

  .directory-toggle:hover {
    color: var(--exitos);
    text-decoration: none;
  }

  .directory-checkbox {
    width: 100%;
  }

  .directory-label {
    display: inline-flex;
    align-items: flex-start;
    flex-grow: 1;
    cursor: pointer;
  }
}
</style>
